/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateRangeLeadsGranular
 */
export interface DateRangeLeadsGranular {
    /**
     * 
     * @type {number}
     * @memberof DateRangeLeadsGranular
     */
    currentTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeLeadsGranular
     */
    unverifiedCurrentTotal?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DateRangeLeadsGranular
     */
    currentGranular?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof DateRangeLeadsGranular
     */
    previousTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeLeadsGranular
     */
    unverifiedPreviousTotal?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DateRangeLeadsGranular
     */
    previousGranular?: { [key: string]: number; };
}

/**
 * Check if a given object implements the DateRangeLeadsGranular interface.
 */
export function instanceOfDateRangeLeadsGranular(value: object): value is DateRangeLeadsGranular {
    return true;
}

export function DateRangeLeadsGranularFromJSON(json: any): DateRangeLeadsGranular {
    return DateRangeLeadsGranularFromJSONTyped(json, false);
}

export function DateRangeLeadsGranularFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateRangeLeadsGranular {
    if (json == null) {
        return json;
    }
    return {
        
        'currentTotal': json['currentTotal'] == null ? undefined : json['currentTotal'],
        'unverifiedCurrentTotal': json['unverifiedCurrentTotal'] == null ? undefined : json['unverifiedCurrentTotal'],
        'currentGranular': json['currentGranular'] == null ? undefined : json['currentGranular'],
        'previousTotal': json['previousTotal'] == null ? undefined : json['previousTotal'],
        'unverifiedPreviousTotal': json['unverifiedPreviousTotal'] == null ? undefined : json['unverifiedPreviousTotal'],
        'previousGranular': json['previousGranular'] == null ? undefined : json['previousGranular'],
    };
}

export function DateRangeLeadsGranularToJSON(json: any): DateRangeLeadsGranular {
    return DateRangeLeadsGranularToJSONTyped(json, false);
}

export function DateRangeLeadsGranularToJSONTyped(value?: DateRangeLeadsGranular | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentTotal': value['currentTotal'],
        'unverifiedCurrentTotal': value['unverifiedCurrentTotal'],
        'currentGranular': value['currentGranular'],
        'previousTotal': value['previousTotal'],
        'unverifiedPreviousTotal': value['unverifiedPreviousTotal'],
        'previousGranular': value['previousGranular'],
    };
}

